import { AudioEngine } from '../audio/engine';
import { GAME_CONFIG } from '../config/gameConfig';
import { clearNdviOverlay, updateCropVisuals } from '../scene/fields';
import type { SceneContext } from '../scene/setup';
import { dronePadPos, truckParkingPos } from '../state/gameState';
import type { GameState } from '../state/types';
import { hideEndScreen } from '../ui/endScreen';
import { createFloatingIndicator } from '../ui/floatingLabel';
import type { DispatchFn } from '../ui/sidebar';
import { updateHTML_UI } from '../ui/sidebar';
import { syncAutopilotUi } from './autopilot';
import { setCommandTool } from './commands';

export function triggerReset(state: GameState, ctx: SceneContext, onDispatch: DispatchFn): void {
  state.cash = GAME_CONFIG.economy.startingCash;
  state.phase = 'playing';
  state.hoveredFieldId = null;
  state.selectedFieldId = null;
  state.autoPilotActive = true;
  hideEndScreen();
  syncAutopilotUi(state);
  setCommandTool(state, 'auto', () => updateHTML_UI(state, onDispatch));

  state.fields.forEach((f) => {
    f.infection =
      Math.floor(Math.random() * GAME_CONFIG.reset.infectionSpan) + GAME_CONFIG.reset.infectionMin;
    f.dead = false;
    clearNdviOverlay(f);

    if (f.soilMat) {
      f.soilMat.color.setHex(0x3a2818);
      f.soilMat.emissive.setHex(0x000000);
      f.soilMat.emissiveIntensity = 0;
    }

    updateCropVisuals(f);
  });

  state.truck.state = 'Idle';
  state.truck.targetFieldId = null;
  state.truck.task = null;
  state.truck.mesh?.position.set(truckParkingPos.x, 0.1, truckParkingPos.z);

  const landY = GAME_CONFIG.units.drone.landAltitude;
  state.drone.state = 'Idle';
  state.drone.targetFieldId = null;
  state.drone.task = null;
  state.drone.y = landY;
  state.drone.mesh?.position.set(dronePadPos.x, landY, dronePadPos.z);

  updateHTML_UI(state, onDispatch);
  createFloatingIndicator(ctx, '🔄 Rendszer Újraindítva!', 0, 0);
  AudioEngine.playBeep(330, 'sine', 0.15);
  setTimeout(() => AudioEngine.playBeep(440, 'sine', 0.15), 100);
  setTimeout(() => AudioEngine.playBeep(554, 'sine', 0.25), 200);
}
